import { useGetCustomerDetailsQuery } from "web/features/customer/customerApiSlice";

const useCustomerLanguage = () => {
  const { data: customer } = useGetCustomerDetailsQuery();
  const { language } = customer || {};
  return { language, isEn: language === "en_GB" };
};

export default useCustomerLanguage;
